import {UNIT_TYPE_PHRASE, UNIT_TYPE_PHRASE_LOCALISED} from '@/constants/Unit';

export const TYPE_ENTITY               = 'entity';
export const TYPE_EXERCISE             = 'exercise';
export const TYPE_UNIT                 = 'unit';
export const EXERCISE_TYPES_TO_NOT_LOG = [
    UNIT_TYPE_PHRASE,
    UNIT_TYPE_PHRASE_LOCALISED,
];
